function LoadingComponent()
{
return (
    <>
     <tr  style={{ textAlign: 'center',position: 'relative',height:'40px'}} >
        
                        <td colSpan="12" style={{ textAlign: 'center', padding: '10px', position: 'absolute', left: ' 0', right: '0' }}>
                            Loading...
                        </td>
                    </tr>   
    </>
);
}

export default LoadingComponent;